import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

import { ConversationService } from '../../shared/services/conversation.service';
import { ChatStateService } from '../../shared/services/chat-state.service';
import { ChatListService } from '../../shared/services/chat-list.service';

import { SvgIconComponent } from '../../shared/components/svg-icon/svg-icon.component';

import { IConversationData } from '../../interfaces/conversations.interfaces';
import { ISvgConfig } from '../../shared/interfaces/svg.interfaces';

import { ESvgTypes } from '../../shared/enums/svg.enums';

@Component({
  selector: 'stxt-chat-item',
  standalone: true,
  imports: [SvgIconComponent, CommonModule],
  templateUrl: './chat-item.component.html',
  styleUrl: './chat-item.component.scss'
})
export class ChatItemComponent implements OnInit, OnChanges, OnDestroy {
  @Input() conversation: IConversationData;
  formattedDate: string;
  verifySvg: ISvgConfig = { fill: ESvgTypes.None, name: 'verified' };
  unreadCount: number = 0;
  private unreadMessagesSubscription: Subscription;

  constructor(
    private router: Router,
    private conversationService: ConversationService,
    private chatStateService: ChatStateService,
    private chatListService: ChatListService
  ) {}

  ngOnInit(): void {
    this.formatData();
    this.subscribeToUnreadMessages();
  }

  ngOnChanges(): void {
    this.formatData();
  }

  formatData(): void {
    this.formattedDate = this.conversationService.getFormattedDate(
      new Date(Number(this.conversation.last_message_timestamp))
    );
  }

  private subscribeToUnreadMessages(): void {
    this.unreadMessagesSubscription = this.chatStateService.unreadMessages$.subscribe(
      unreadState => {
        this.unreadCount = unreadState[this.conversation.conversation_id] || 0;
      }
    );
  }

  selectChat(): void {
    const creatorId = this.conversation.conversation_id.split('-')[0];
    this.router.navigate(['/chat', creatorId]);
    this.chatListService.selectConversation(this.conversation.conversation_id);
    if (window.innerWidth < 640) {
      this.chatListService.isChatsFullScreen.next(false);
    }
  }

  ngOnDestroy(): void {
    if (this.unreadMessagesSubscription) {
      this.unreadMessagesSubscription.unsubscribe();
    }
  }
}
